import { takeLatest, call, put } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import {
  setEmandates,
  setEmandateDetail,
  setAuditTrails,
} from '../actions/emandateAction';
import * as SnackbarAction from '../actions/snackbarAction';

function* getEmandate(action) {
  try {
    const response = yield call(callApi, URLS.SEARCH, 'GET', action.payload);
    yield put(setEmandates(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.statusText,
        type: 'error',
      }),
    );
  }
}

function* getEmandateDetail(action) {
  try {
    const response = yield call(
      callApi,
      URLS.MANDATE_DETAILS,
      'GET',
      action.payload,
    );
    // const obj = {
    //   mandate_id: 'E-MYUT5374822',
    //   created_at: '2021-10-05 17:30:29',
    //   start_date: '2021-10-05',
    //   frequency: 'MONTHLY',
    //   merchant_name: 'Netflix',
    //   merchant_logo:
    //     'https://s3-us-west-1.amazonaws.com/cavacserv9dev/COMPANY_LOGO/HPLOGO2019724916475434165069HP.png',
    //   recurring_count: 2,
    //   end_date: '2021-12-20',
    //   amount_type: 'Fixed',
    //   amount: 2000,
    //   status: 'Created',
    //   expected_txn_date: '2021-11-05',
    // };
    yield put(setEmandateDetail(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.statusText,
        type: 'error',
      }),
    );
  }
}

function* getAuditTrails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.EMANDATE_AUDIT_TRAILS,
      'GET',
      action.payload,
    );
    // const obj = [
    //   {
    //     created_by: 'Priyank Bhagel',
    //     created_at: '2019-02-28T12:38:51Z',
    //     old_value: {
    //       start_date: '2021-08-20',
    //       frequency: 'MONTHL',
    //       recurring_count: 10,
    //       end_date: '2021-11-20',
    //       amount_type: 'Fixe',
    //       amount: 1001,
    //       status: 'Create',
    //       expected_txn_date: '2021-08-20',
    //     },
    //     new_value: {
    //       start_date: '2021-08-21',
    //       frequency: 'MONTHLY',
    //       recurring_count: 11,
    //       end_date: '2021-11-21',
    //       amount_type: 'Fixed',
    //       amount: 1000,
    //       status: 'Created',
    //       expected_txn_date: '2021-08-23',
    //     },
    //   },
    //   {
    //     created_by: 'Vaibhav Dedhai',
    //     created_at: '2019-02-28T12:38:51Z',
    //     old_value: {
    //       start_date: '2021-08-20',
    //       frequency: 'MONTHL',
    //       recurring_count: 10,
    //       end_date: '2021-11-20',
    //       amount_type: 'Fixe',
    //       amount: 1001,
    //       status: 'Create',
    //       expected_txn_date: '2021-08-20',
    //     },
    //     new_value: {
    //       start_date: '2021-08-21',
    //       frequency: 'MONTHLY',
    //       recurring_count: 11,
    //       end_date: '2021-11-21',
    //       amount_type: 'Fixed',
    //       amount: 1000,
    //       status: 'Deleted',
    //       expected_txn_date: '2021-08-23',
    //     },
    //   },
    // ];
    yield put(setAuditTrails(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.statusText,
        type: 'error',
      }),
    );
  }
}

export function* EmandateSaga() {
  yield takeLatest('GET_EMANDATE', getEmandate);
  yield takeLatest('GET_EMANDATE_DETAIS', getEmandateDetail);
  yield takeLatest('GET_AUDIT_TRAILS', getAuditTrails);
}
